import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { AuthResponse } from 'src/app/shared/models/api-response/auth-response';
import { ConstantsService } from '../../constant/constants.service';
import { DataStorageService } from '../../dataStorage/data-storage.service';
import { GenericCrudService } from '../../generic-crud.service';

class AuthRequest {
	login: string;
	password: string;
}

@Injectable({
	providedIn: 'root'
})
export class AuthenticationService {
	constructor(
		private appConstants: ConstantsService,
		private jwtHelper: JwtHelperService,
		private dataStorageService: DataStorageService,
		private genericCrudService: GenericCrudService
	) {}

	authenticate(login: string, password: string): Observable<AuthResponse> {
		const request: AuthRequest = new AuthRequest();
		request.login = login;
		request.password = password;
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.authUrl}/signin`,
			`authenticate`,
			request
		);
	}

	public isAuthenticated(): boolean {
		const token = this.dataStorageService.getJwtToken();
		if (!token) {
			return false;
		}
		return !this.jwtHelper.isTokenExpired(token);
	}

	public confirmAccount(token: string): Observable<any> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.authUrl}/confirm/${token}`,
			'confirmAccount'
		);
	}

	public setPasswordConfirmationAccount(
		token: string,
		password: string
	): Observable<any> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.authUrl}/confirm/${token}`,
			`setPasswordConfirmationAccount`,
			password
		);
	}

	public refreshToken(login: string): Observable<any> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.authUrl}/refresh/token`,
			`refreshToken`,
			login
		);
	}
}
